import { http } from '@/http/index'

async function saveGuestMessages(data) {
	return http.post(`/messages/guest/save`, { data }).then((response) => response?.data)
}

export { saveGuestMessages }
